import { render, staticRenderFns } from "./DisassemblyRecord.vue?vue&type=template&id=48a1a5e5&scoped=true&"
import script from "./DisassemblyRecord.vue?vue&type=script&lang=js&"
export * from "./DisassemblyRecord.vue?vue&type=script&lang=js&"
import style0 from "./DisassemblyRecord.vue?vue&type=style&index=0&id=48a1a5e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1a5e5",
  null
  
)

export default component.exports